import {
  OFFERING_OR_ENTITLEMENT,
  getOfferingOrEntitlement,
} from '@jarvis/react-portal-addons';

/**
 * Constants for entitlement states
 */
export const ENTITLEMENT_STATES = {
  OFFERING: ['Published'],
  ENTITLEMENT: ['ENABLED', 'DISABLED', 'PENDING'],
};

/**
 * Checks if any entitlement exists in grants data
 * @param {Object} grantsData - The grants data object
 * @param {Array} entitlements - Array of entitlement strings to check
 * @returns {boolean} True if any entitlement is found in grants data
 */
export const hasActiveGrants = (grantsData, entitlements) => entitlements.some(
  entitlement => !!grantsData?.[entitlement],
);

/**
 * Checks if any entitlement has offerings
 * @param {Object} programData - The program data object
 * @param {Array} entitlements - Array of entitlement strings to check
 * @param {Array} states - Array of valid offering states (default: ['Published'])
 * @returns {boolean} True if any entitlement has offerings
 */
export const hasOfferingsForEntitlements = (
  programData,
  entitlements,
  states = ENTITLEMENT_STATES.OFFERING,
) => entitlements.some(
  entitlement => !!getOfferingOrEntitlement(
    programData,
    entitlement,
    { states },
    OFFERING_OR_ENTITLEMENT.OFFERING,
  ),
);

/**
 * Checks if any entitlement has entitlements
 * @param {Object} programData - The program data object
 * @param {Array} entitlements - Array of entitlement strings to check
 * @param {Array} states - Array of valid entitlement states (default: ['ENABLED', 'DISABLED', 'PENDING'])
 * @returns {boolean} True if any entitlement has entitlements
 */
export const hasEntitlementsForEntitlements = (
  programData,
  entitlements,
  states = ENTITLEMENT_STATES.ENTITLEMENT,
) => entitlements.some(
  entitlement => !!getOfferingOrEntitlement(
    programData,
    entitlement,
    { states },
    OFFERING_OR_ENTITLEMENT.ENTITLEMENT,
  ),
);

export const EntitlementState = {
  Enabled: 'ENABLED',
  Published: 'Published',
  Disabled: 'DISABLED',
  Pending: 'PENDING',
};
